module.exports = __webpack_public_path__ + "img/verify_tick.53119ddc.svg";